'use strict';

module.exports = {
  getMessage: function getMessage(field, params, data) {
    return 'El campo ' + field + ' no es un rut v\xE1lido';
  },
  validate: function validate(rut) {
    if (typeof rut !== 'string') {
      return false;
    }

    var cRut = rut.replace(/[\.-]/g, '');
    var cDv = cRut.charAt(cRut.length - 1).toUpperCase();
    var nRut = parseInt(cRut.substr(0, cRut.length - 1));
    if (isNaN(nRut)) {
      return false;
    }

    var sum = 0;
    var factor = 2;

    nRut = nRut.toString();
    for (var i = nRut.length - 1; i >= 0; i--) {
      sum = sum + nRut.charAt(i) * factor;
      factor = (factor + 1) % 8 || 2;
    }

    var computedDv = 0;

    switch (sum % 11) {
      case 1:
        computedDv = 'k';
        break;
      case 0:
        computedDv = 0;
        break;
      default:
        computedDv = 11 - sum % 11;
        break;
    }

    return computedDv.toString().toUpperCase() === cDv.toString().toUpperCase();
  }
};
